/**
 * @file Pont entree -> simulation : direction ECRAN (joystick) convertie en direction MONDE selon le lacet de la camera, transmise a sim.setInput.
 */
import { RENDER } from '@config/index';
import type { Simulation } from '@core/index';
import type { ScreenInput } from '@platform/input/PointerInput';

/**
 * Ecran : x droite, y BAS. Monde core : x droite, y vers le fond (nord). Camera de lacet `yaw` (0 = regarde vers +y core) :
 * monde = rotation(yaw) de (sx, -sy).
 */
export const screenToWorld = (sx: number, sy: number, yawDeg: number): { x: number; y: number } => {
  const yaw = (yawDeg * Math.PI) / 180;
  const ux = sx;
  const uy = -sy;
  return { x: ux * Math.cos(yaw) - uy * Math.sin(yaw), y: ux * Math.sin(yaw) + uy * Math.cos(yaw) };
};

export class InputBridge {
  constructor(
    private readonly sim: Simulation,
    private readonly input: ScreenInput,
  ) {}

  /** Appele avant chaque tic. */
  apply(): void {
    const w = screenToWorld(this.input.x, this.input.y, this.sim.getView().rules.cameraYawDeg ?? RENDER.camera.yawDeg);
    this.sim.setInput(w.x, w.y, this.input.active);
  }
}
